export default [
  {codigo: 'AGUARDANDO_ANALISE', nome: 'Aguardando Análise'},
  {codigo: 'AGUARDANDO_PORTARIA', nome: 'Aguardando Portaria'},
  {codigo: 'AGUARDANDO_VALIDACAO', nome: 'Aguardando validação base'},
  {codigo: 'AGUARDANDO_VALIDACAO_PORTARIA', nome: 'Aguardando Validação da Portaria'},
  {codigo: 'AGUARDANDO_ARQUIVAMENTO', nome: 'Aguardando Arquivamento'},
  {codigo: 'AGUARDANDO_PUBLICACAO', nome: 'Aguardando Publicação'},
  {codigo: 'AGUARDANDO_ENTREGA', nome: 'Aguardando Entrega'},
  {codigo: 'AGUARDANDO_RECEBIMENTO', nome: 'Aguardando recebimento do título'},
  {codigo: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura'},
  {codigo: 'AGUARDANDO_VALIDACAO_BASE', nome: 'Aguardando validação base'},
  {codigo: 'AGUARDANDO_ATUALIZACAO_BASE', nome: 'Aguardando atualização base'},
  {codigo: 'AGUARDANDO_EDITAL', nome: 'Aguardando edital'},
  {codigo: 'AGUARDANDO_MANIFESTO', nome: 'Aguardando Manifesto'},
  {codigo: 'AGUARDANDO_EMISSAO_TITULO', nome: 'Aguardando emissão do título'},
  {codigo: 'AGUARDANDO_VALIDACAO_TITULO', nome: 'Aguardando validação do título'},
  {codigo: 'AGUARDANDO_EMISSAO_CERTIDAO', nome: 'Aguardando emissão da certidão'},
  {codigo: 'AGUARDANDO_VALIDACAO_CERTIDAO', nome: 'Aguardando validação da certidão'},
  {codigo: 'AGUARDANDO_CONFERENCIA_TITULO', nome: 'Aguardando conferência do título'},
  {codigo: 'EM_CONFERENCIA_TITULO', nome: 'Em conferência do título'},
  {codigo: 'AGUARDANDO_CONFERENCIA_CERTIDAO', nome: 'Aguardando conferência da certidão'},
  {codigo: 'AGUARDANDO_CONFIRMACAO_INTERESSADO', nome: 'Aguardando confirmação do interessado'},
  {codigo: 'AGUARDANDO_PAGAMENTO', nome: 'Aguardando Pagamento do Boleto'},
  {codigo: 'AGUARDANDO_BOLETO', nome: 'Aguardando emissão do boleto'},
  {codigo: 'AGUARDANDO_EMISSAO', nome: 'Aguardando Emissão'},
  {codigo: 'AGUARDANDO_DISTRIBUICAO', nome: 'Aguardando Distribuição'},
  {codigo: 'AGUARDANDO_VALIDACAO_ANALISE', nome: 'Aguardando validação analise'},
  {codigo: 'EM_ANALISE', nome: 'Em análise'},
  {codigo: 'EM_EMISSAO_PORTARIA', nome: 'Em emissão da certidão'},
  {codigo: 'EM_EMISSAO_CERTIDAO', nome: 'Em emissão da certidão'},
  {codigo: 'EM_ARQUIVAMENTO', nome: 'Em arquivamento'},
  {codigo: 'EM_EMISSAO_TITULO', nome: 'Em emissão do título'},
  {codigo: 'ENVIADO_PARA_PUBLICACAO', nome: 'Enviado para  publicação'},
  {codigo: 'ARQUIVADO', nome: 'Arquivado'},
  {codigo: 'FINALIZADO', nome: 'Finalizado'},
  {codigo: 'ASSINADO', nome: 'Assinado'},
  {codigo: 'ENTREGUE', nome: 'Entregue'},
  {codigo: 'CANCELADO', nome: 'Cancelado'},
  {codigo: 'VENCIDO', nome: 'Vencido'},
  {codigo: 'AGUARDANDO_EMISSAO_PARCELA', nome: 'Aguardando Emissão Parcela'},
  {codigo: 'ENVIADO_PUBLICACAO', nome: 'Enviado para Publicação'},
  {codigo: 'ANALISE_FINALIZADA', nome: 'Análise Finalizada'},
  {codigo: 'AGUARDANDO_TRANSFERENCIA', nome: 'Aguardando transferencia'},
  {codigo: 'AGUARDANDO_RETORNO_RESGATE', nome: 'Aguardando retorno do resgate'},
  {codigo: 'AGUARDANDO_DOCUMENTACAO', nome: 'Aguardando documentação'},
  {codigo: 'AGUARDANDO_CALCULO_CUSTAS', nome: 'Aguardando cálculo das custas'},
  {codigo: 'AGUARDANDO_PAGAMENTO_CUSTAS', nome: 'Aguardando pagamento das custas'},
  {codigo: 'RECEBIDO', nome: 'Recebido'},
  {codigo: 'PORTARIA_EMITIDA', nome: 'Portaria emitida'},
  {codigo: 'AGUARDANDO_CALCULO_VTN', nome: 'Aguardando calculo VTN'},
  {codigo: 'AGUARDANDO_PAGAMENTO_VTN', nome: 'Aguardando pagamento VTN'},
  {codigo: 'EM_REVISAO_VALIDACAO', nome: 'Em revisão validação'},
  {codigo: 'AGUARDANDO_ANALISE_VISTORIA', nome: 'Aguardando análise de vistoria'},
  {codigo: 'EM_ANALISE_VISTORIA', nome: 'Em análise de vistoria'},
  {codigo: 'AGUARDANDO_ANALISE_DOCUMENTAL', nome: 'Aguardando análise documental'},
  {codigo: 'EM_ANALISE_DOCUMENTAL', nome: 'Em análise documental'},
  {codigo: 'AGUARDANDO_ANALISE_DISTRIBUICAO', nome: 'Aguardando análise distribuição'},
  {codigo: 'EM_ANALISE_DISTRIBUICAO', nome: 'Em análise distribuição'},
  {codigo: 'AGUARDANDO_VALIDACAO_DISTRIBUICAO', nome: 'Aguardando validação da distribuição'},
  {codigo: 'AGUARDANDO_ANALISE_GEO', nome: 'Aguardando análise geo'},
  {codigo: 'EM_ANALISE_GEO', nome: 'Em análise geo'},
  {codigo: 'AGUARDANDO_ANALISE_VALIDACAO_GEO', nome: 'Aguardando análise validação geo'},
  {codigo: 'AGUARDANDO_ANALISE_VERIFICACAO_GEO', nome: 'Aguardando análise verificação geo'},
  {codigo: 'EM_ANALISE_VALIDACAO_GEO', nome: 'Em análise validação geo'},
  {codigo: 'AGUARDANDO_VALIDACAO_DOCUMENTAL', nome: 'Aguardando validação documental'},
  {codigo: 'EM_RETIFICACAO_EM_EMISSAO_TITULO', nome: 'Em retificação'},
  {codigo: 'AGUARDANDO_DISPONIBILIDADE_TITULO', nome: 'Aguardando disponibilidade do título'},
  {codigo: 'AGUARDANDO_DOCUMENTOS_INTERESSADO', nome: 'Aguardando documentos do interessado'},
  {codigo: 'AGUARDANDO_VALIDACAO_DOCUMENTOS', nome: 'Aguardando validação dos documentos'},
  {codigo: 'AGUARDANDO_ANALISE_LAUDO_VISTORIA', nome: 'Aguardando análise do laudo de vistoria'},
  {codigo: 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA', nome: 'Aguardando assinatura Extrato de Sentença'},
  {codigo: 'AGUARDANDO_EMISSAO_EXTRATO_SENTENCA', nome: 'Aguardando emissão do Extrato de Setença'},
  {codigo: 'EM_EMISSAO_EXTRATO_SENTENCA', nome: 'Em emissão do Extrato de Setença'},
  {codigo: 'AGUARDANDO_ANALISE_FINALIZACAO', nome: 'Aguardando Análise de Finalização'},
  {codigo: 'EM_ANALISE_FINALIZACAO', nome: 'Em Análise de Finalização'},
  {codigo: 'AGUARDANDO_VALIDACAO_FINALIZACAO', nome: 'Aguardando Validação de Finalização'},
  {codigo: 'VALIDADO_FINALIZACAO', nome: 'Validado Finalização'},
  {codigo: 'EM_RETIFICACAO_EM_ANALISE', nome: 'Em analise retificação'},
  {codigo: 'SUSPENSO', nome: 'Suspenso'},
  {codigo: 'AGUARDANDO_SUSPENSAO', nome: 'Aguardando Suspensao'}
]



// WEBPACK FOOTER //
// ./src/constants/statusProcessos.js